import { defineComponent } from 'vue';
import phoneDemo from './components/phoneDemo.vue';
export default defineComponent({
  name: 'App',
  components: {
    phoneDemo
  }
});